import { z } from 'zod'

// Schema for pagination links
const PaginationLinkSchema = z.object({
  url: z.string().nullable(),
  label: z.string(),
  active: z.boolean(),
})

// Generic pagination schema that can be used with any data type
const PaginationSchema = z.object({
  current_page: z.number(),
  first_page_url: z.string(),
  from: z.number().nullable(),
  last_page: z.number(),
  last_page_url: z.string(),
  links: z.array(PaginationLinkSchema),
  next_page_url: z.string().nullable(),
  path: z.string(),
  per_page: z.number(),
  prev_page_url: z.string().nullable(),
  to: z.number().nullable(),
  total: z.number(),
})

// Helper function to create a paginated response schema for any data type
function createPaginatedResponseSchema<T extends z.ZodTypeAny>(dataSchema: T) {
  return PaginationSchema.extend({
    data: z.array(dataSchema),
  })
}

// Type definitions
type PaginationLink = z.infer<typeof PaginationLinkSchema>
type Pagination = z.infer<typeof PaginationSchema>

// Generic paginated response type
type PaginatedResponse<T> = Pagination & {
  data: T[]
}

export type { PaginationLink, Pagination, PaginatedResponse }
export { PaginationLinkSchema, PaginationSchema, createPaginatedResponseSchema }
